/**
 * abilityVfxDarius — Darius Q/W/E/R Noxian silhouettes (SPY-32).
 */
export function buildDecimate(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 2);
  const red = mat(THREE, spec.color || 0xb91c1c, 0.88);
  const steel = mat(THREE, 0xfca5a5, 0.92);
  addAxeArc(THREE, group, s, red, steel);
  addGroundRing(THREE, group, s, red);
  group.userData = { shape: 'decimate' };
  return group;
}

export function buildCripplingStrike(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.5 * (spec.scale || 1.25);
  const red = mat(THREE, spec.color || 0xdc2626, 0.9);
  const dark = mat(THREE, 0x450a0a, 0.85);
  addAxeHead(THREE, group, s, red, dark);
  addFootRing(THREE, group, s, red);
  group.userData = { shape: 'crippling_strike' };
  return group;
}

export function buildApprehend(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.4);
  const dark = mat(THREE, spec.color || 0x7f1d1d, 0.9);
  const steel = mat(THREE, 0xf87171, 0.92);
  addHookCone(THREE, group, s, dark, steel);
  group.userData = { shape: 'apprehend' };
  return group;
}

export function buildNoxianGuillotine(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.65 * (spec.scale || 1.65);
  const red = mat(THREE, spec.color || 0xef4444, 0.92);
  const steel = mat(THREE, 0xfecaca, 0.95);
  addFallingAxe(THREE, group, s, red, steel);
  addImpactRing(THREE, group, s, red);
  group.userData = { shape: 'noxian_guillotine' };
  return group;
}

function addAxeArc(THREE, group, s, red, steel) {
  for (let i = 0; i < 4; i += 1) {
    const blade = new THREE.Mesh(new THREE.BoxGeometry(s * 0.9, 0.08, 0.2), steel);
    blade.position.y = 0.45;
    if (!blade.rotation) blade.rotation = { y: 0 };
    blade.rotation.y = (Math.PI / 2) * i;
    group.add(blade);
  }
  const hub = new THREE.Mesh(new THREE.SphereGeometry(0.16 * s, 8, 8), red);
  hub.position.y = 0.45;
  group.add(hub);
}

function addGroundRing(THREE, group, s, red) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.55, s * 1.05, 24).rotateX(-Math.PI / 2),
    red
  );
  ring.position.y = 0.05;
  group.add(ring);
}

function addAxeHead(THREE, group, s, red, dark) {
  const haft = new THREE.Mesh(new THREE.BoxGeometry(0.08 * s, 1.0 * s, 0.08 * s), dark);
  haft.position.y = 0.7 * s;
  group.add(haft);
  const head = new THREE.Mesh(new THREE.BoxGeometry(0.55 * s, 0.22 * s, 0.1 * s), red);
  head.position.y = 1.15 * s;
  group.add(head);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.28 * s, 4), red);
  tip.position.set(0.3 * s, 1.15 * s, 0);
  group.add(tip);
}

function addFootRing(THREE, group, s, red) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.4, s * 0.95, 18).rotateX(-Math.PI / 2),
    red
  );
  ring.position.y = 0.05;
  group.add(ring);
}

function addHookCone(THREE, group, s, dark, steel) {
  for (let i = -1; i <= 1; i += 1) {
    const arm = new THREE.Mesh(
      new THREE.BoxGeometry(0.1 * s, 0.08 * s, 0.9 * s),
      steel
    );
    arm.position.set(i * 0.35 * s, 0.35 * s, 0.35 * s);
    if (!arm.rotation) arm.rotation = { y: 0 };
    arm.rotation.y = i * 0.35;
    group.add(arm);
  }
  const hook = new THREE.Mesh(new THREE.ConeGeometry(0.18 * s, 0.45 * s, 5), dark);
  hook.position.set(0, 0.35 * s, 0.85 * s);
  group.add(hook);
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.14 * s, 8, 8), steel);
  core.position.set(0, 0.35 * s, 0.1 * s);
  group.add(core);
}

function addFallingAxe(THREE, group, s, red, steel) {
  const blade = new THREE.Mesh(new THREE.BoxGeometry(0.7 * s, 0.2 * s, 0.1 * s), steel);
  blade.position.y = 1.4 * s;
  group.add(blade);
  const haft = new THREE.Mesh(new THREE.CylinderGeometry(0.05 * s, 0.07 * s, 1.4 * s, 8), red);
  haft.position.y = 0.9 * s;
  group.add(haft);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.35 * s, 4), red);
  tip.position.y = 0.25 * s;
  if (!tip.rotation) tip.rotation = { x: 0 };
  tip.rotation.x = Math.PI;
  group.add(tip);
}

function addImpactRing(THREE, group, s, red) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.3, s * 0.85, 20).rotateX(-Math.PI / 2),
    red
  );
  ring.position.y = 0.05;
  group.add(ring);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
